import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

interface TriggerDiscoveryDto {
  coverage_areas?: string[];
  region?: string;
}

class TrendingService {
  async getTrendingTopics(filters: any = {}) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.TRENDING_TOPICS.LIST, filters);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching trending topics:', error);
      throw error;
    }
  }

  async triggerDiscovery(payload: TriggerDiscoveryDto = {}) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.TRENDING_TOPICS.DISCOVER, payload);
      return response.data.data;
    } catch (error) {
      console.error('Error triggering trending topics discovery:', error);
      throw error;
    }
  }
}

export const trendingService = new TrendingService();
